import { render, staticRenderFns } from "./InputAutocompleteProjectAreaItem.vue?vue&type=template&id=aa495524&scoped=true"
import script from "./InputAutocompleteProjectAreaItem.vue?vue&type=script&lang=js"
export * from "./InputAutocompleteProjectAreaItem.vue?vue&type=script&lang=js"
import style0 from "./InputAutocompleteProjectAreaItem.vue?vue&type=style&index=0&id=aa495524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa495524",
  null
  
)

export default component.exports